import { daoPost } from 'mrf/Dao';
import { useFormDataSelector, useFormSelector } from 'mrf/redux/ReduxHelper';
import { loadJwt, userErrorHandler } from 'mrf/utils/LoginUtils';
import Button from 'mrf/view/Button';
import { FormContext } from 'mrf/view/FormCRUD';
import { Col, Grid } from 'mrf/view/Grid';
import Paper from 'mrf/view/Paper';
import TextField from 'mrf/view/TextField';
import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import mrf from 'mrf.config';
import IF from '../IF';
import T from 'mrf/utils/T';
import Text from 'mrf/layout/Text';
import path from 'path';
import buildInfo from "../../../buildInfo.json";
import CheckboxField from "../CheckboxField";

export default function LoginForm() {
    const match = useRouteMatch();

    const { commitHash } = buildInfo;

    const context = useFormSelector({
        resource: 'loginForm',
        endpoint: '/api/Users/Login',
        blankForm: () => ({ username: '', password: '', commitHash }),
    });

    const data = useFormDataSelector(context);

    const handleSubmit = async e => {
        e.preventDefault();

        try {
            const ret = await daoPost('/api/Users/Login', data);
            loadJwt(ret);
        } catch (e) {
            userErrorHandler(e, context)
        }
    }

    return <FormContext.Provider value={context}>
        <Paper as='form' onSubmit={handleSubmit}>
            <Grid gap={4}>
                <Col size={12} justify='center'>
                    <IF condition={!!mrf.loginImage}>
                        <figure className="mb-3">
                            <img src={mrf.loginImage} width={mrf?.loginImageWidth} alt="logo" />
                        </figure>
                    </IF>
                    <Text variant='h4' className='text-3xl text-center uppercase'>
                        {mrf?.applicationName}
                    </Text>
                </Col>
                <Col size={12}>
                    <TextField
                        label='Username'
                        field='username'
                    />
                </Col>
                <Col size={12}>
                    <TextField
                        label='Password'
                        field='password'
                        type='password'
                    />
                </Col>

                <IF condition={!!data?.requiresTwoFactor}>
                    <Col size={12}>
                        <TextField
                            label='Verification Code'
                            field='code'
                        />
                    </Col>
                    <Col size="12">
                        <CheckboxField
                            label={'Remember this computer?'}
                            field={'isTrustedClient'}
                        />
                    </Col>
                </IF>

                <IF condition={!!data?.licenseRequestCode}>
                    <Col size={12}>
                        <TextField
                            label='License Request Code'
                            field='licenseRequestCode'
                        />
                    </Col>
                    <Col size={12}>
                        <TextField
                            label='License'
                            field='license'
                        />
                    </Col>
                </IF>

                <Col size={12} />
                <Col size={12}>
                    <Button color='primary' type='submit'>Log in</Button>
                </Col>
                <Col size={12} justify='center'>
                    <Link to={path.join(match.url, 'forgotPassword')}><T>Forgot your password?</T></Link>
                </Col>
            </Grid>
        </Paper>
    </FormContext.Provider>
}
